// extracted by mini-css-extract-plugin
export default {"container":"kP2TbIHUQF7aquDqfeAA","content":"EOw2en4sLZyBTg61gbg3"};